// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gs-0";
export var headerCellHover = "_gs-1";
export var readCellContainer = "_gs-2";
export var unreadIndicator = "_gs-3";